import React from "react";
import ShiftExchangesManagement from "pages/ShiftExchangesManagement";

const ShiftExchangesManaged = (props) => (
	<ShiftExchangesManagement {...props} mode="managed" />
);

export default ShiftExchangesManaged;
